// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scheduleTemplate {
  background-color: #f3f4f6;
}
.scheduleTemplate .scheduleTemplateTitleBar {
  display: flex;
  align-content: space-between;
  width: 74vw;
  margin: auto;
  padding-top: 60px;
  padding-bottom: 24px;
}
.scheduleTemplate .scheduleTemplateTitleBar .header {
  display: inline-block;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  color: #333333;
}
.scheduleTemplate .scheduleTemplateTitleBar .button {
  display: inline-block;
  width: 101px;
  height: 50px;
  background: #075453;
  border-radius: 8px;
  color: white;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #ffffff;
  margin-left: auto;
  border: none;
  padding-top: 15px;
}
.scheduleTemplate .container {
  margin: auto;
  width: 90%;
  text-align: center;
}
.scheduleTemplate .container .emptyTemplateCard {
  min-width: 529px;
  width: 36.73vw;
  display: inline-block;
  margin: 9px;
}`, "",{"version":3,"sources":["webpack://./src/screens/scheduleTemplate/scheduleTemplate.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;AACJ;AACI;EACI,aAAA;EACA,4BAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;AACR;AACQ;EACI,qBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AACZ;AACQ;EACI,qBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;AACZ;AAGI;EACI,YAAA;EACA,UAAA;EACA,kBAAA;AADR;AAEQ;EACI,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,WAAA;AAAZ","sourcesContent":[".scheduleTemplate {\n    background-color: #f3f4f6;\n\n    .scheduleTemplateTitleBar {\n        display: flex;\n        align-content: space-between;\n        width: 74vw;\n        margin: auto;\n        padding-top: 60px;\n        padding-bottom: 24px;\n\n        .header {\n            display: inline-block;\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 28px;\n            line-height: 38px;\n            color: #333333;\n        }\n        .button {\n            display: inline-block;\n            width: 101px;\n            height: 50px;\n            background: #075453;\n            border-radius: 8px;\n            color: white;\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 16px;\n            line-height: 22px;\n            text-align: center;\n            color: #ffffff;\n            margin-left: auto;\n            border: none;\n            padding-top: 15px;\n        }\n    }\n\n    .container {\n        margin: auto;\n        width: 90%;\n        text-align: center;\n        .emptyTemplateCard {\n            min-width: 529px;\n            width: 36.73vw;\n            display: inline-block;\n            margin: 9px;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
